import { useEffect } from 'react';

// How many mounted callers currently want scrolling off. A nested modal (a
// confirm opened from inside another modal) must not re-enable scrolling
// when it closes while the outer one is still open.
let lockCount = 0;

const setNoScroll = (on: boolean) => {
  document.body.classList.toggle('noscroll', on);
  const mainElement = document.querySelector('main');
  if (mainElement) mainElement.classList.toggle('noscroll', on);
};

/**
 * Hook to disable body scrolling
 * @param shouldDisable Optional parameter to conditionally disable scrolling (defaults to true for backward compatibility)
 */
const useDisableBodyScroll = (shouldDisable: boolean = true) => {
  useEffect(() => {
    if (shouldDisable) {
      lockCount += 1;
      setNoScroll(true);
      return () => {
        lockCount = Math.max(0, lockCount - 1);
        if (lockCount === 0) setNoScroll(false);
      };
    }

    // Not disabling: clear a stale class, unless someone else holds a lock.
    if (lockCount === 0) setNoScroll(false);
    return undefined;
  }, [shouldDisable]);
};

export default useDisableBodyScroll;
